<template>
  <div
    class="cell-prize"
    :class="{ 'cell-prize-green': record.prize.value > 0, 'cell-prize_disabled': !canEdit }"
    @click="canEdit && (calculateType === 'byPeriod' ? (isShowPremiumPeriodModal = true) : (isShowPremiumPeriodModal = true))"
  >
    <!--<m-write-premium
      v-if="calculateType === 'byDate'"
      :calc-data="calculationData"
      :record="record"
      :active="isShowWritePremiumModal"
      @close="isShowWritePremiumModal = false"
      @submitPremium="submitPremium"
    />-->
    <m-show-premium-period-modal
      v-if="calculateType === 'byPeriod'"
      :active="isShowPremiumPeriodModal"
      :record="record"
      :calc-data="calculationData"
      @close="isShowPremiumPeriodModal = false"
      @updateBonuses="updateBonuses"
    />
    <m-show-premium-period-modal
      v-if="calculateType === 'byDate'"
      :active="isShowPremiumPeriodModal"
      :record="record"
      :calc-data="calculationData"
      @close="isShowPremiumPeriodModal = false"
      @updateBonuses="updateBonuses"
    />    
    <div :class="{ 'cell-prize-value-grey': record.prize.value.toString() === '0' }" class="cell-prize-value">
      {{ record.prize.value }}
    </div>
  </div>
</template>

<script>
import WritePremiumModal from "@/pages/calculations/create/additions/modal-production-write-premium";
import ShowPremiumByCalculationPeriod from "@/pages/calculations/create/additions/calculation-by-period-modals/show-premium-modal";

export default {
  name: "production-cell-prize",
  components: {
    "m-write-premium": WritePremiumModal,
    "m-show-premium-period-modal": ShowPremiumByCalculationPeriod,
  },
  props: ["record", "calculationData", "calculateType", "canEdit"],
  data() {
    return {
      isShowWritePremiumModal: false,
      isShowPremiumPeriodModal: false,
    };
  },
  methods: {
    updateBonuses(params) {
      //alert("!");
      this.$emit("updateBonuses", params)
    },    
    submitPremium(items) {
      //alert("!!");
      let sum = 0;
      this.record.prize.items = [];
      items.forEach((item) => {
        sum += Number(item.amountLocal);
        this.record.prize.items.push({
          amount: item.amountLocal,
          author_id: item.authorLocalValue.value,
          reason: item.basisLocalValue.label,
          reason_id: item.basisLocalValue.value,
        });
      });
      this.record.prize.value = sum;
    },
  },
};
</script>
<style lang="scss" scoped>
.cell-prize {
  line-height: 13px;
  font-size: 13px;
  padding: 10px;
  -webkit-transition: 0.2s;
  transition: 0.2s;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  &-green {
    background: #d0f4e3;
  }

  &:hover {
    outline-style: solid;
    outline-width: 1px !important;
    outline-color: #0066ff !important;
    box-shadow: 0 0 10px rgba(0, 102, 255, 0.4);
  }

  &_disabled {
    cursor: default;

    &:hover {
      outline: none;
      box-shadow: none;
    }
  }

  &-value {
    &-grey {
      color: #8e9cbb;
    }
  }
}
</style>
